import { Component, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {
  ConductivityprofileElementsViewModel,
  Conductivityprofiles,
  FieldValue,
  Fields,
  ListConductivityprofiles,
} from 'src/app/models/conductivityprofiles.model';
import { Plant } from 'src/app/models/plant.model';
import { Train } from 'src/app/models/train.model';
import { ConductivityprofilesService } from 'src/app/services/conductivityprofiles/conductivityprofiles.service';
import { PlantsService } from 'src/app/services/plants/plants.service';
import { TrainService } from 'src/app/services/trains/trains.service';

@Component({
  selector: 'app-add-conductivityprofiles',
  templateUrl: './add-conductivityprofiles.component.html',
  styleUrls: ['./add-conductivityprofiles.component.scss'],
})
export class AddConductivityprofilesComponent {
  [x: string]: any;

  constructor(
    private router: Router,
    private plantsService: PlantsService,
    private trainService: TrainService,
    private conductivityprofilesservice: ConductivityprofilesService,
    private toastr: ToastrService
  ) {}

  ConductivityprofilesDetails: Conductivityprofiles =
    new Conductivityprofiles();
  fields: Fields = new Fields();
  formatsDateTest: string[] = ['yyyy/MM/dd HH:mm:ss'];
  plants: Plant[] = [];
  trains: Train[] = [];
  ListConductivityprofiles: ListConductivityprofiles[] = [];
  dateNow: Date = new Date();
  SelectedId: string;
  fieldValue: FieldValue[] = [];
  fieldValueModel: FieldValue = new FieldValue();
  stage2PvIds: any;
  stage3PvIds: any;
  stage1PvIds: any;
  tableData: any;
  permCondValues: { [pvId: string]: string } = {};
  selectedDatetime: string = '';
  ConductivityprofileElementsViewModel: ConductivityprofileElementsViewModel[] =
    [];

    loggedInUserRole:string;
    loggedinUserId:string;
    plantAndUserId:string;

  getSelectedId(e) {
    this.SelectedId = e.target.value;
    this.stage1PvIds = [];
    this.stage2PvIds = [];
    this.stage3PvIds = [];


    if(this.loggedInUserRole =='Standard User')
      {
    this.plantAndUserId = this.SelectedId + 'Z' + this.loggedinUserId;
    this.trainService.GetAccessibleTrainListByPlantId(this.plantAndUserId)
      
      .subscribe(
        (response: Train[]) => {
          this.trains = response;
        },
        (error: any) => {
          console.log('error list');
        }
      );
  }
  else
  {
    this.trainService.getTrainByPlantId(this.SelectedId).subscribe(
      (response: Train[]) => {
        this.trains = response;
      },

      (error: any) => {
        console.log('error list');
      }
    );
  }
  }
  getPermCond(item: any, pvId: string): number {
    const entry = item[pvId];
    return entry ? entry : null;
  }
  getSelectedTrainId(e) {
    this.SelectedId = e.target.value;
    this.trainId = this.SelectedId;
    this.stage1PvIds = [];
    this.stage2PvIds = [];
    this.stage3PvIds = [];
    this.getConductivityprofilesData(this.trainId);
  }

  getConductivityprofilesData(TrainId) {
    this.ListConductivityprofiles.length = 0;
    this.conductivityprofilesservice
      .getConductivityprofilesListByTrainId(TrainId)
      .subscribe((response: ListConductivityprofiles[]) => {
        this.ListConductivityprofiles = response;
        console.log(this.ListConductivityprofiles);
        const formattedData = this.ListConductivityprofiles.map((item) => ({
          stage: `Stage ${item.Stage}`,
          pvId: item.PvId,
          date: item.TableshortcodeDatetime,
          value: item.PermCond || '-',
        }));

        formattedData.sort(
          (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()
        );

        console.log('formattedData :', formattedData);

        const transformedData = formattedData.reduce((acc, curr) => {
          const existingItem = acc.find(
            (item) => item.stage === curr.stage && item.pvId === curr.pvId
          );
          if (existingItem) {
            existingItem[curr.date] = curr.value || '-';
          } else {
            const newItem = {
              stage: curr.stage,
              pvId: curr.pvId,
              [curr.date]: curr.value || '-',
            };
            acc.push(newItem);
          }
          return acc;
        }, []);
        console.log(transformedData);
        this.tableData = transformedData;
        const stage1Data = formattedData.filter(
          (item) => item.stage === 'Stage 1'
        );
        const stage2Data = formattedData.filter(
          (item) => item.stage === 'Stage 2'
        );
        const stage3Data = formattedData.filter(
          (item) => item.stage === 'Stage 3'
        );

        this.stage1PvIds = [...new Set(stage1Data.map((item) => item.pvId))];
        this.stage2PvIds = [...new Set(stage2Data.map((item) => item.pvId))];
        this.stage3PvIds = [...new Set(stage3Data.map((item) => item.pvId))];

        console.log('Stage 1 pvIds:', this.stage1PvIds);
        console.log('Stage 2 pvIds:', this.stage2PvIds);
        console.log('Stage 3 pvIds:', this.stage3PvIds);
      });
  }

  isDate(value: unknown): boolean {
    return typeof value === 'string' && !isNaN(Date.parse(value as string));
  }

  distinctDates(data: any[]): string[] {
    const dates = new Set<string>();
    data.forEach((item) => {
      Object.keys(item).forEach((key) => {
        if (this.isDate(key)) {
          dates.add(key);
        }
      });
    });
    return Array.from(dates);
  }

  ngOnInit(): void {
    let loggedInuserRole = JSON.parse(atob(sessionStorage.getItem('currentUser')!));
    if(loggedInuserRole.role =='Standard User')
    {
      this.loggedInUserRole = loggedInuserRole.role;
      this.loggedinUserId = loggedInuserRole.userId;
      this.plantsService.getPlantsByUserId(loggedInuserRole.userId)
      .subscribe({
        next: (plants)=>{
          this.plants = plants;
        },
      })
      
    }
    else
    {
    this.plantsService.getAllPlant().subscribe({
      next: (plants) => {
        this.plants = plants;
      },
      error: (response) => {
        console.log(response);
      },
    });
  }
     //load data using plantId from breadcrumbs
    this.plantsService.selectedPlant$.subscribe(plantId => {
      if (plantId) {
          this.getSelectedId({ target: { value: plantId } });
      }
    });

    //load data using trainid from breadcrumbs
    this.plantsService.selectedTrain$.subscribe(trainId => {
      if (trainId) {
          this.getSelectedTrainId({ target: { value: trainId } });
      }
    });
  }
  updateDatetime(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    this.selectedDatetime = inputElement.value;
  }

  reloader() {
    window.location.reload();
  }

  addConductivityProfile() {
    const allPvIdPermCondList: ConductivityprofileElementsViewModel[] = [];

    const pushDataForStage = (stage: number, pvIds: string[]) => {
      for (const pvId of pvIds) {
        if (this.permCondValues[pvId] !== undefined) {
          allPvIdPermCondList.push({
            TrainId: Number(this.trainId),
            TableshortcodeDatetime: this.selectedDatetime,
            Stage: stage,
            PvId: pvId,
            PermCond: Number(this.permCondValues[pvId]),
          });
        }
      }
    };

    pushDataForStage(1, this.stage1PvIds);

    if (this.stage2PvIds.length > 0) {
      pushDataForStage(2, this.stage2PvIds);
    }

    if (this.stage3PvIds.length > 0) {
      pushDataForStage(3, this.stage3PvIds);
    }
    console.log('PV Ids and PermCond values:', allPvIdPermCondList);

    this.conductivityprofilesservice
      .addConductivityprofiles(allPvIdPermCondList)
      .subscribe({
        next: (model) => {
          this.toastr.success(
            'Conductivity Profile Added Successfully.',
            'Information'
          );
          this.router.navigate(['/conductivityprofile']);
        },
      });
  }
}
